import api from './api'
import { User, Tenant } from './types'

export const authService = {
  async getCurrentUser(): Promise<User> {
    const response = await api.get<User>('/auth/me')
    return response.data
  },

  async getCurrentTenant(): Promise<Tenant> {
    const response = await api.get<Tenant>('/tenants/current')
    return response.data
  },

  async logout(): Promise<void> {
    await api.post('/auth/logout')
  },
}
